define([
	"dojo/_base/declare",
	"csi/heading/Number"
], function(declare,NumberRen) {

	return declare(NumberRen, {
		formatValue: function(/*Any*/value, /*String?*/fmt) {
			// summary: if printing specific view then print using normal time format rather than Diff format
			if (value != null) {
				return "0x" + value.toString(16);
			}
			
			return this.inherited(arguments);
		},
		
		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: restrict filtering for heading
			return null;
		}
	});
});